module.exports = __webpack_public_path__ + "static/media/doc-1.a86dcb0e.jpg";